import React, { useState, useEffect } from "react";
import MainBody from "../../../component/MainBody";
import { getdropdownList } from "../../../utils/HelperFunction";
import httpRequest from "../../../utils/Http";
import Select from "react-select";
import MyDataTable from "../../../component/MyDataTable";
import { useSelector } from "react-redux";
import { EMPLOYEE_TYPE, PARTNER_TYPE } from "../../../constant/status_constant";
import { toast } from "react-toastify";

const WarehouseStock = () => {
  let loggedInUser = useSelector((state) => state.authReducer.currentUser);
  const [warehouselist, setWarehouselist] = useState([]);
  const [applianceList, setApplianceList] = useState([]);
  const [partnerList, setPartnerList] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [formData, setFormData] = useState({
    warehouse_id: "",
    appliance_id: "",
    partner_id: "",
  });
  const [isSubmit, setSubmit] = useState(true);
  const [reloadList, setReload] = useState(false);

  const handleQuantityChange = (row, qty) => {
    const quantity = Number(qty);

    if (quantity < 0 || quantity > row.stock) return;

    setSelectedItems((prev) => {
      const index = prev.findIndex((item) => item.id === row.id);

      // REMOVE if quantity = 0
      if (quantity === 0) {
        return prev.filter((item) => item.id !== row.id);
      }

      // UPDATE if already exists
      if (index !== -1) {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          quantity,
        };
        return updated;
      }

      // ADD new
      return [
        ...prev,
        {
          id: row.id,
          warehouse_id: row.entity_id,
          partner_id: row.partner_id,
          quantity,
          msl_line_item: row.msl_line_item,
          part_id: row.part_id,
          part_name: row.part_name,
          part_number: row.part_number,
        },
      ];
    });
  };

  useEffect(() => {
    (async () => {
      const warehouse = await httpRequest("getcwhdropdownlist", {}, "GET");
      if (warehouse.status === true && warehouse.data) {
        setWarehouselist(warehouse.data);
        if (Number(warehouse.data.length) === 1) {
          setFormData({
            ...formData,
            warehouse_id: warehouse.data[0]["value"],
          });
          setReload(true);
        }
      }

      if (Number(loggedInUser.entity_type) === PARTNER_TYPE) {
        setFormData({ ...formData, partner_id: loggedInUser.entity_id });
        getdropdownList(
          setApplianceList,
          `appliancelistmapping?is_active=1&partner_id=${loggedInUser.entity_id}`,
        );
      } else {
        getdropdownList(setPartnerList, `getpartnerlist?is_active=1`);
      }
    })();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (formData.partner_id) {
      getdropdownList(
        setApplianceList,
        `appliancelistmapping?is_active=1&partner_id=${formData.partner_id}`,
      );
    }
  }, [formData?.partner_id]);

  // const onSubmitHandler = (e) => {
  //   e.preventDefault();
  //   setSubmit(false);
  //   setFormErrors(validateFrom(formData));
  //   setSubmit(true);
  // };

  useEffect(() => {
    if (formData.warehouse_id) {
      setFormErrors({})
      setSubmit(true);
      setReload(true);
    } else {
      setFormErrors((prev) => ({
        ...prev,
        warehouse_id: "Central Warehouse is Required",
      }));
    }

  }, [formData]);

  // const validateFrom = (value) => {
  //   const errors = {};
  //   if (!value.warehouse_id) {
  //     errors.warehouse_id = "Central Warehouse is Required";
  //   }

  //   return errors;
  // };

  useEffect(() => {
    (async () => {
      
      if (Object.keys(formErrors).length === 0 && isSubmit) {
        setSelectedItems([])
        setReload(true);
        setSubmit(false);
      }
    })();
    //eslint-disable-next-line
  }, [isSubmit, formErrors]);

  const columns = [
    {
      name: "SNo.",
      selector: (row) => "", // Placeholder, as we don't need to select data from the row itself
      cell: (row, index) => index + 1, // Use cell to render the incrementing number
    },
    Number(loggedInUser.entity_type) === PARTNER_TYPE && {
      name: <div className="word-wrap">Display Name</div>,
      selector: (row) => row.display_name,
      wrap: true,
    },
    Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && {
      name: <div className="word-wrap">Partner</div>,
      selector: (row) => row.partner_name,
      wrap: true,
    },
    {
      name: "Appliance",
      selector: (row) => row.appliance_name,
      wrap: true,
    },
    {
      name: "Part Type",
      selector: (row) => row.part_type,
      wrap: true,
    },
    {
      name: "Part Name",
      selector: (row) => row.part_name,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Part Number</div>,
      selector: (row) => row.part_number,
      wrap: true,
    },
    {
      name: "HSN Code",
      selector: (row) => row.hsn_code,
      wrap: true,
    },
    {
      name: <div className="word-wrap">GST Rate (%)</div>,
      selector: (row) => row.gst_rate,
      wrap: true,
    },
    {
      name: <div className="word-wrap">Total Buying Price</div>,
      selector: (row) => (row.basic_rate * (1 + row.gst_rate / 100)).toFixed(2),
      wrap: true,
    },
    Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && {
      name: <div className="word-wrap">SF Buying Price</div>,
      selector: (row) =>
        (
          row.basic_rate *
          (1 + row.gst_rate / 100) *
          (1 + row.partner_oow_margin / 100)
        ).toFixed(2),
      wrap: true,
    },
    Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && {
      name: <div className="word-wrap">Customer Price</div>,
      selector: (row) =>
        (
          row.basic_rate *
          (1 + row.gst_rate / 100) *
          (1 + (row.sf_oow_margin + row.partner_oow_margin) / 100)
        ).toFixed(2),
      wrap: true,
    },
    {
      name: <div className="word-wrap">Stock Quantity</div>,
      selector: (row) => row.stock,
    },
    Number(loggedInUser.entity_type) === EMPLOYEE_TYPE && {
      name: <div className="word-wrap">Select Qty</div>,
      cell: (row) => (
        <input
          disabled={formData.partner_id && !reloadList ? false : true}
          type="number"
          min={0}
          max={row.stock}
          value={
            selectedItems.find((item) => item.id === row.id)?.quantity || ""
          }
          onChange={(e) => handleQuantityChange(row, e.target.value)}
          className="form-control"
          style={{ width: "80px" }}
        />
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
  ].filter(Boolean);

  const submitSelectedQuantity = async () => {
    if (!selectedItems.length) {
      alert("Please select at least one quantity");
      return;
    }

    const response = await httpRequest(
      "okmsltobereturnedfromwarehouse",
      { data: selectedItems, warehouse_id: formData.warehouse_id, partner_id: formData.partner_id },
      "POST",
    );

    if (response.status) {
      toast.success(response.message);
      setSelectedItems([]);
      setReload(true);
    } else {
      toast.error(response.message);
    }
  };

  return (
    <div>
      <MainBody
        breadcrumbTitle="Warehouse Stock"
        breadcrumbSubTitle={"List"}
        navButton={""}
        title={""}
        component={
          <>
            <section className="content">
              <div className="container-fluid">
                <form
                  id="mslintranist"
                  // onSubmit={onSubmitHandler}
                  encType="multipart/form-data"
                >
                  <div className="card card-default">
                    <div className="card-header">
                      <h3 className="card-title">Filter</h3>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>
                              Central Warehouse *{" "}
                              <span style={{ color: "red" }}>
                                {formErrors.warehouse_id}
                              </span>
                            </label>
                            <Select
                              name="warehouse_id"
                              value={
                                warehouselist.find(
                                  (option) =>
                                    option.value === formData.warehouse_id,
                                ) || null
                              }
                              options={warehouselist}
                              onChange={(val) => {
                                setFormData({
                                  ...formData,
                                  warehouse_id: val.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        {Number(loggedInUser.entity_type) !== PARTNER_TYPE && (
                          <>
                            <div className="col-md-3">
                              <div className="form-group">
                                <label>
                                  Partner{" "}
                                  <span style={{ color: "red" }}>
                                    {formErrors.partner_id}
                                  </span>
                                </label>
                                <Select
                                  name="partner_id"
                                  value={
                                    partnerList.find(
                                      (option) =>
                                        option.value === formData.partner_id,
                                    ) || null
                                  }
                                  options={partnerList}
                                  onChange={(val) => {
                                    setFormData({
                                      ...formData,
                                      partner_id: val.value,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                          </>
                        )}
                        <div className="col-md-3">
                          <div className="form-group">
                            <label>
                              Appliance{" "}
                              <span style={{ color: "red" }}>
                                {formErrors.appliance_id}
                              </span>
                            </label>
                            <Select
                              name="appliance_id"
                              value={
                                applianceList.find(
                                  (option) =>
                                    option.value === formData.appliance_id,
                                ) || null
                              }
                              options={applianceList}
                              onChange={(val) => {
                                setFormData({
                                  ...formData,
                                  appliance_id: val.value,
                                });
                              }}
                            />
                          </div>
                        </div>

                        {/* <div className="col-md-3">
                      
                          <div className="form-group">
                            <label>
                              .{" "}
                              <span style={{ color: "red" }}>
                                {formErrors.part_file}
                              </span>
                            </label>
                            <input
                              type="submit"
                              className="form-control btn btn-primary"
                              value={"Submit"}
                            />
                          </div>

                   
                        </div> */}
                        {/* /.col */}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </section>

            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <h3 className="card-title">Warehouse Stock</h3>
                      </div>
                      {formData.warehouse_id && (
                        <MyDataTable
                        reloadList={reloadList}
                        columns={columns}
                        getDataListURL={`getwarehousestock?entity_id=${formData.warehouse_id}&partner_id=${formData.partner_id}&appliance_id=${formData.appliance_id}&entity_type=4`}
                        setReload={setReload}
                        exportName={"whstocklist"}
                      />
                      )}
                      
                    </div>
                  </div>
                </div>
              </div>
            </section>

                {Number(loggedInUser?.entity_type) === EMPLOYEE_TYPE && (
                  <div className="card-body d-flex justify-content-between align-items-center">
                    <span>
                      Selected Items: <b>{selectedItems.length}</b>
                    </span>

                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={submitSelectedQuantity}
                      disabled={selectedItems.length === 0}
                    >
                      Submit for MSL Return
                    </button>
                  </div>
                )}

          </>
        }
      />
    </div>
  );
};

export default WarehouseStock;
